module.exports = __webpack_public_path__ + "static/media/analogyFifth.a9fbaaaa.svg";